module.exports = __webpack_public_path__ + "static/media/Vector_selected.a75d1c28.svg";